export const accounting = {
  kicker: 'Админка',
  title: 'Бухгалтерия',
  tabsAria: 'Разделы бухгалтерии',
  tabs: { summary: 'Итог', expenses: 'Расходы', incomes: 'Доходы', settings: 'Настройки' },
  common: {
    retry: 'Повторить',
    cancel: 'Отмена',
    save: 'Сохранить',
    saving: 'Сохраняю…',
    add: 'Добавить',
    edit: 'Изменить',
    delete: 'Удалить',
    deleting: 'Удаляю…',
    loadFailed: 'Не удалось загрузить данные',
    saved: 'Сохранено',
    deleted: 'Удалено',
    actions: 'Действия',
    dash: '—',
    from: 'С месяца',
    to: 'По месяц',
    reset: 'Текущий месяц',
    rangeInvalid: 'Начало периода позже конца.',
    rangeTooLong: 'Период — не больше 36 месяцев.',
    rangeAria: 'Период',
  },
  errors: {
    generic: 'Не удалось выполнить действие',
    sourceCodeExists: 'Источник с таким кодом уже есть.',
    sourceCodeInvalid: 'Код источника: a-z, 0-9, дефис, подчёркивание, до 64 символов.',
    unknownSource: 'Такого источника нет.',
    unknownParticipant: 'Такого участника нет.',
    amountInvalid: 'Некорректная сумма.',
    rateInvalid: 'Некорректная ставка: от 0 до 100 %.',
    shareInvalid: 'Некорректная доля: от 0 до 100 %.',
    monthInvalid: 'Некорректный месяц.',
    periodInvalid: 'Некорректный период: не больше 36 месяцев, начало не позже конца.',
    receiptUrlInvalid: 'Некорректная ссылка на чек.',
    notFound: 'Запись не найдена, обновите страницу.',
  },
  summary: {
    loadFailed: 'Не удалось загрузить итог',
    empty: 'Данных за период пока нет.',
    sharesWarning: (percent: string) => `Сумма долей участников ${percent}, а должна быть 100 %. Выплаты посчитаны неверно — поправьте доли в настройках.`,
    taxNote: (percent: string) => `Налог: ${percent} от выручки.`,
    monthsTitle: 'По месяцам',
    monthsAria: 'Итог по месяцам',
    columns: {
      month: 'Месяц',
      gross: 'Выручка',
      commission: 'Комиссии',
      tax: 'Налог',
      expenses: 'Расходы',
      net: 'Чистыми',
      margin: 'Маржа',
      payout: (name: string) => `К выплате: ${name}`,
    },
    totalRow: 'Всего',
    periodTitle: 'За месяц',
    periodSelect: 'Период',
    allTime: 'За всё время',
    kpi: { gross: 'Выручка', commission: 'Комиссии', tax: 'Налог', expenses: 'Расходы', net: 'Чистыми' },
    payoutsTitle: 'Выплаты участникам',
    payoutShare: 'Доля чистыми',
    payoutReimbursement: 'Возврат расходов',
    payoutTotal: 'К выплате',
    shareOf: (percent: string) => `доля ${percent}`,
    inactive: 'неактивен',
    noParticipants: 'Нет активных участников.',
  },
  expenses: {
    title: 'Расходы',
    add: 'Добавить расход',
    loadFailed: 'Не удалось загрузить расходы',
    empty: 'Расходов за период нет.',
    totalLabel: 'Итого за период',
    tableAria: 'Список расходов',
    columns: { date: 'Дата', category: 'Категория', description: 'Описание', amount: 'Сумма', paidBy: 'Кто платил', receipt: 'Чек' },
    fromProject: 'Из денег проекта',
    receiptOpen: 'Открыть',
    receiptAria: (category: string) => `Открыть чек: ${category}`,
    editAria: (category: string, date: string) => `Изменить расход: ${category}, ${date}`,
    deleteAria: (category: string, date: string) => `Удалить расход: ${category}, ${date}`,
    dialog: {
      createTitle: 'Новый расход',
      editTitle: 'Изменить расход',
      date: 'Дата',
      category: 'Категория',
      categoryHint: 'Выберите из списка или введите свою.',
      description: 'Описание',
      amount: 'Сумма, ₽',
      paidBy: 'Кто платил',
      receipt: 'Ссылка на чек',
      dateRequired: 'Укажите дату.',
      categoryRequired: 'Укажите категорию.',
      categoryTooLong: 'Категория — до 64 символов.',
      descriptionTooLong: 'Описание — до 500 символов.',
      amountInvalid: 'Сумма должна быть больше нуля, не более двух знаков после запятой.',
      receiptTooLong: 'Ссылка — до 1000 символов.',
    },
    deleteDialog: {
      title: 'Удалить расход?',
      body: (category: string, amount: string, date: string) => `Расход «${category}» на ${amount} от ${date} будет удалён без возможности восстановления.`,
    },
  },
  incomes: {
    autoTitle: 'Доходы магазина',
    autoNote: 'Считаются автоматически по оплаченным заказам, только чтение.',
    autoEmpty: 'Оплаченных заказов магазина за период нет.',
    autoAria: 'Доходы магазина по месяцам',
    autoColumns: { month: 'Месяц', source: 'Источник', orders: 'Заказов', amount: 'Сумма', commission: 'Комиссия' },
    manualTitle: 'Ручные доходы',
    add: 'Добавить доход',
    loadFailed: 'Не удалось загрузить доходы',
    manualEmpty: 'Ручных доходов за период нет.',
    manualAria: 'Список ручных доходов',
    columns: { month: 'Месяц', source: 'Источник', amount: 'Сумма', note: 'Заметка' },
    editAria: (source: string, month: string) => `Изменить доход: ${source}, ${month}`,
    deleteAria: (source: string, month: string) => `Удалить доход: ${source}, ${month}`,
    dialog: {
      createTitle: 'Новый доход',
      editTitle: 'Изменить доход',
      month: 'Месяц',
      source: 'Источник',
      amount: 'Сумма, ₽',
      note: 'Заметка',
      monthRequired: 'Укажите месяц.',
      sourceRequired: 'Выберите источник.',
      amountInvalid: 'Сумма должна быть больше нуля, не более двух знаков после запятой.',
      noteTooLong: 'Заметка — до 500 символов.',
    },
    deleteDialog: {
      title: 'Удалить доход?',
      body: (source: string, amount: string, month: string) => `Доход «${source}» на ${amount} за ${month} будет удалён без возможности восстановления.`,
    },
  },
  settings: {
    loadFailed: 'Не удалось загрузить настройки',
    sources: {
      title: 'Источники доходов и комиссии',
      add: 'Добавить источник',
      tableAria: 'Источники доходов',
      columns: { title: 'Название', code: 'Код', commission: 'Комиссия', note: 'Заметка' },
      storeBadge: 'Магазин',
      editAria: (title: string) => `Изменить источник: ${title}`,
      dialog: {
        createTitle: 'Новый источник',
        editTitle: 'Изменить источник',
        code: 'Код',
        codeHint: 'Латиница, цифры, дефис и подчёркивание, до 64 символов. Потом не меняется.',
        title: 'Название',
        commission: 'Комиссия, %',
        note: 'Заметка',
        codeInvalid: 'Код: a-z, 0-9, дефис, подчёркивание, от 1 до 64 символов.',
        titleRequired: 'Укажите название.',
        titleTooLong: 'Название — до 128 символов.',
        percentInvalid: 'Процент — число от 0 до 100.',
        noteTooLong: 'Заметка — до 500 символов.',
      },
    },
    participants: {
      title: 'Участники и доли',
      add: 'Добавить участника',
      tableAria: 'Участники',
      columns: { name: 'Имя', share: 'Доля', active: 'Статус' },
      active: 'Активен',
      inactive: 'Неактивен',
      editAria: (name: string) => `Изменить участника: ${name}`,
      sumLabel: (percent: string) => `Сумма долей активных: ${percent}`,
      sumOk: 'Всё сходится',
      sumBad: 'Должно быть 100 %',
      deactivateHint: 'Неактивным доля не начисляется, их расходы остаются в учёте.',
      dialog: {
        createTitle: 'Новый участник',
        editTitle: 'Изменить участника',
        name: 'Имя',
        share: 'Доля, %',
        active: 'Активен',
        nameRequired: 'Укажите имя.',
        nameTooLong: 'Имя — до 128 символов.',
        percentInvalid: 'Процент — число от 0 до 100.',
      },
    },
    tax: {
      title: 'Налог',
      label: 'Ставка налога, % от выручки',
      hint: 'Одна текущая ставка для всех месяцев.',
      invalid: 'Ставка — число от 0 до 100.',
    },
  },
};
